import Loadable from 'react-loadable';

export const ExternalPurchaseDoc = Loadable({
  loader: () => import('./ExternalPurchaseDoc'),
  loading: () => null,
});


// WEBPACK FOOTER //
// ./src/containers/ExternalPurchaseDoc/index.tsx